import { orderSelectors } from 'ducks/orderComponents'
import {
  COMPONENTS_V2_RESOURCE,
  joinCodesForComponentsV2Filter,
} from 'elements/hardwareSelectorV2/fetch/useComponentsV2List'
import { useCallback, useLayoutEffect, useMemo, useState } from 'react'
import { useDataProvider } from 'react-admin'
import { useDispatch, useSelector, useStore } from 'react-redux'
import restClient from 'restClient'
import { RootState } from 'types/state'
import ProjectOrderPresenter from '../ProjectOrderPresenter/projectOrderPresenter'
import ProjectTablePresenter from './projectTablePresenter'

export type SelectedSystemMapType = {
  [id: number]: number
}

export type ProjectTableStore = {
  selectedSystemMap: SelectedSystemMapType
  loadingSystemIds: Set<number>
}

const defaultStoreValue: ProjectTableStore = {
  selectedSystemMap: {},
  loadingSystemIds: new Set(),
}

const useProjectTable = (): [ProjectTableStore, ProjectTablePresenter] => {
  const [projectTableStore, setProjectTableStore] = useState<ProjectTableStore>(defaultStoreValue)
  const store = useStore<RootState>()
  const dispatch = useDispatch()
  const dataProvider = useDataProvider()
  const lineItems = useSelector(orderSelectors.getOrderLineItems)

  const fetchComponentsDataAsync = useCallback(
    async (codes: string[]): Promise<any[]> => {
      if (!codes.length) return []
      const { data } = await dataProvider.getList(COMPONENTS_V2_RESOURCE, {
        pagination: { page: 1, perPage: Math.max(codes.length, 1) },
        sort: { field: '_default_rule', order: 'ASC' },
        filter: { codes: joinCodesForComponentsV2Filter(codes) },
      })
      return data || []
    },
    [dataProvider]
  )

  const orderingPresenter = useMemo(
    () => new ProjectOrderPresenter(store, dispatch, restClient(window.API_ROOT + '/api')),
    [store, dispatch]
  )

  const projectTablePresenter = useMemo(
    () => new ProjectTablePresenter(setProjectTableStore, orderingPresenter, dataProvider, fetchComponentsDataAsync),
    [setProjectTableStore, orderingPresenter, dataProvider, fetchComponentsDataAsync]
  )

  useLayoutEffect(() => {
    projectTablePresenter.populateSelectedSystemMap(lineItems)
  }, [])

  return [projectTableStore, projectTablePresenter]
}

export default useProjectTable
